import mqtt from "mqtt";

class MqttManager {
  constructor() {
    this.clients = {}; // نگهداری کلاینت‌ها
  }

  connect(deviceId, brokerUrl, options) {
    const existingClient = this.clients[deviceId];

    // اگر کلاینت قبلی وجود دارد و قطع یا خراب شده، حذفش کن
    if (
      existingClient &&
      (existingClient.disconnected || existingClient.disconnecting)
    ) {
      // console.warn(`🔁 حذف کلاینت خراب‌شده برای ${deviceId}`);
      try {
        existingClient.end(true);
      } catch (err) {
        // console.error("❌ خطا هنگام end:", err.message);
      }
      delete this.clients[deviceId];
    }

    // اگر کلاینت سالم هست، مجدد استفاده کن
    if (this.clients[deviceId]) {
      return this.clients[deviceId];
    }

    // اتصال جدید
    const mqttClient = mqtt.connect(brokerUrl, options);

    // mqttClient.on("connect", () => {
    //   console.log(`✅ Device ${deviceId} connected.`);
    // });

    // mqttClient.on("error", (err) => {
    //   console.error(`❌ Device ${deviceId} connection error:`, err.message);
    // });

    // mqttClient.on("close", () => {
    //   console.warn(`⚠️ Device ${deviceId} connection closed.`);
    // });

    this.clients[deviceId] = mqttClient;
    return mqttClient;
  }

  disconnect(deviceId) {
    const client = this.clients[deviceId];
    if (client) {
      // console.log(`🔌 Disconnecting device ${deviceId}`);
      try {
        client.end(true); // قطع فوری، بدون انتظار
      } catch (err) {
        // console.error("❌ خطا در disconnect:", err.message);
      }
      delete this.clients[deviceId];
    }
  }

  publish(deviceId, topic, message) {
    const client = this.clients[deviceId];
    if (client?.connected) {
      client.publish(topic, message);
    } else {
      // console.warn(`⚠️ Cannot publish: client ${deviceId} not connected`);
    }
  }

  subscribe(deviceId, topic) {
    const client = this.clients[deviceId];
    if (client?.connected) {
      client.subscribe(topic, (err) => {
        if (err) {
          // console.error(`❌ Subscribe error on ${topic}:`, err.message);
        } else {
          // console.log(`📥 Subscribed to ${topic}`);
        }
      });
    }
  }

  unsubscribe(deviceId, topic) {
    const client = this.clients[deviceId];
    if (client?.connected) {
      client.unsubscribe(topic, (err) => {
        if (err) {
          // console.error(`❌ Unsubscribe error on ${topic}:`, err.message);
        } else {
          // console.log(`🚫 Unsubscribed from ${topic}`);
        }
      });
    }
  }
}

export default MqttManager;
